export default __webpack_public_path__ + "static/media/VarusValgus.06dd3edd.png";